module.exports = __webpack_public_path__ + "static/media/u35_premium_contract12.780c56b6.webp";